/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HeaderMenu_manager = {
    readonly company: {
        readonly name: string;
    };
    readonly " $refType": "HeaderMenu_manager";
};
export type HeaderMenu_manager$data = HeaderMenu_manager;
export type HeaderMenu_manager$key = {
    readonly " $data"?: HeaderMenu_manager$data;
    readonly " $fragmentRefs": FragmentRefs<"HeaderMenu_manager">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "HeaderMenu_manager",
    "type": "Manager",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "company",
            "storageKey": null,
            "args": null,
            "concreteType": "Company",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'de3c1f8fe78cab169851b9a0f0159e43';
export default node;
